<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("history.detail")
      }}</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <img v-if="details.Data.photo || details.Data.avatar" class="img-card" :src="details.Data.avatar? details.Data.avatar:(details.Data.photo[0]?details.Data.photo[0]:details.Data.photo)" alt="">
            <a-form :layout="formLayout">
              <a-form-item
                v-for="key in Object.keys(details)"
                :key="key"
                :label="key"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <span v-if="key == 'created'">{{
                  details[key] | formatDate
                }}</span>
                <span v-else>{{ details[key] }}</span>
              </a-form-item>
              <a-form-item
                v-if="
                  bool &&
                    details.Data.location &&
                    details.Data.location.longitude
                "
                label=" "
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <iframe
                  width="300"
                  height="170"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  :src="
                    `https://maps.google.com/maps?q=` +
                      details.Data.location.latitude  +
                      `,` +
                      details.Data.location.longitude +
                      `&hl=es&z=14&amp;output=embed`
                  "
                >
                </iframe>
                <br />
                <small>
                  <a
                    :href="
                      `https://maps.google.com/maps?q=` +
                        details.Data.location.latitude +
                        `,` +
                       details.Data.location.longitude +
                        `&hl=es;z=14&amp;output=embed`
                    "
                    style="color:#0000FF;text-align:left"
                    target="_blank"
                  >
                    See map bigger
                  </a>
                </small>
              </a-form-item>

              <router-link :to="`/addtran/${$route.params.id}`">
                <a-form-item
                  v-if="bool"
                  label=" "
                  :label-col="formItemLayout.labelCol"
                  :wrapper-col="formItemLayout.wrapperCol"
                >
                  <a-button
                    type="primary"
                    icon="plus-circle"
                    :loading="loading"
                    >{{ $t("addTran") }}</a-button
                  >
                </a-form-item>
              </router-link>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
import config from "@/config";
export default {
  data() {
    return {
      loading: false,
      details: {},
      formLayout: "horizontal",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px"
      },
      loading: false,
      coin: "",
      bool: false
    };
  },
  methods: {
    loadDetail() {
      this.api("admin/user?action=detail&id=" + this.$route.params.id).then(
        res => {
          this.details = res;
          console.log("Vi tri", res)
          this.bool = true;
        }
      );
    },
    updateStatus() {
      this.loading = true;
      this.api("admin/transaction", {
        status: this.details.status,
        id: this.$route.params.id,
        paid: parseInt(this.paid)
      })
        .then(res => {
          console.log(res);
        })
        .finally(e => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.loadDetail();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    }
  },
  mixins: [api, helper]
};
</script>
<style scoped>
.img-card{
  width: 200px;
  position: absolute;
  top: 10px;
  right: 20px;
}
</style>
